const isIntegerWithoutDecimals = (value) => {
  if (!value) return true;
  if (value.toString().includes(',') || value.toString().includes('.')) return false;
  return !Number.isNaN(parseInt(value, 10));
};

export default isIntegerWithoutDecimals;
